import { Component, OnInit } from '@angular/core';
import { UnSubscribeComponent } from '../../_shared/un-subscribe.component';
import { ActivatedRoute } from '@angular/router';
import { InsightsService } from '../../../services/insights-service';
import { environment } from '../../../environments/_active-environment/environment';

@Component({
  selector: 'app-sso-logout',
  templateUrl: './sso-logout.component.html',
  styleUrls: ['./sso-logout.component.scss'],
  standalone: false,
})
export class SsoLogoutComponent extends UnSubscribeComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private insightsService: InsightsService,
  ) {
    super();
  }

  ngOnInit() {
    if (environment.name === 'altiuslife-dev') {
      this.redirectToCrossDomainUrl();
      return;
    }

    const redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('redirect_url');

    if (redirectUrl) {
      setTimeout(() => {
        window.localStorage.clear();
        window.location.href = redirectUrl;
      }, 1000);
      return;
    }

    this.redirectToCrossDomainUrl();
  }

  private redirectToCrossDomainUrl() {
    this.insightsService.getCrossDomainUrl().subscribe(crossDomainUrl => {
      setTimeout(() => {
        window.localStorage.clear();
        window.location.href = crossDomainUrl;
      }, 1000);
    });
  }
}
